import { ClinicRegister, ClinicRegisterSuccess, LoginPage } from '@/pages';
import { offAuthRedirect, onAuthRedirect } from '@/services/core';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';

import ProtectedRoute from '@/components/auth/protected-route';
import { ErrorBoundary } from '@/components/common/error-boundary';
import ForceError from '@/components/common/force-error';
import AdminLayout from '@/components/layout/admin-layout';
import { ToastProvider } from '@/components/shared';
import { useEffect } from 'react';
import { ROUTES } from './constants';

const App = () => {
	const navigate = useNavigate();

	// Listen for global auth redirect events (e.g., after logout)
	useEffect(() => {
		const handler = ({ path }: { path: string }) => {
			navigate(path, { replace: true });
		};

		onAuthRedirect(handler);
		return () => {
			offAuthRedirect(handler);
		};
	}, [navigate]);

	return (
		<ErrorBoundary>
			<ToastProvider>
				<Routes>
					{/* Public routes */}
					<Route path={ROUTES.LOGIN} element={<LoginPage />} />
					<Route path={ROUTES.CLINIC_REGISTER} element={<ClinicRegister />} />
					<Route path={ROUTES.CLINIC_REGISTER_SUCCESS} element={<ClinicRegisterSuccess />} />

					{/* Temporary route to test Error Boundary */}
					<Route path="/test-error" element={<ForceError />} />

					{/* Protected admin routes */}
					<Route
						path='/*'
						element={
							<ProtectedRoute>
								<AdminLayout />
							</ProtectedRoute>
						}
					/>

					{/* Catch-all route for direct access to nested routes */}
					<Route path='*' element={<Navigate to={ROUTES.DASHBOARD} replace />} />
				</Routes>
			</ToastProvider>
		</ErrorBoundary>
	);
};

export { App };
export default App;
